// Loox SVG Fix - Move SVG from head to body
(function() {
    'use strict';

    // Function to move SVG from head to body
    function moveLooxSvgToBody() {
        // Find the Loox SVG in head
        const looxSvg = document.querySelector('head svg#loox-rating-icon-svg-store');

        if (looxSvg) {
            // Create a container div for the SVG
            const svgContainer = document.createElement('div');
            svgContainer.id = 'loox-svg-container';
            svgContainer.style.display = 'none';
            svgContainer.appendChild(looxSvg);

            // Move to body
            document.body.appendChild(svgContainer);

            console.log('Loox SVG moved from head to body successfully');
        }
    }

    // Run immediately if DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', moveLooxSvgToBody);
    } else {
        moveLooxSvgToBody();
    }

    // Also run on window load to catch any late-loading elements
    window.addEventListener('load', moveLooxSvgToBody);

})();